import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteAiProvider } from '@/lib/api/generated/api';

import { toAiProviderError } from '../errors';
import { aiProviderKeys } from '../queryKeys';

/**
 * Delete an AI Provider outright.
 *
 * Refused with `AiProviderHasDependentProfilesError` while any LLM Profile
 * still references it (FR-009), or `AiProviderIsDefaultError` while it is the
 * default (FR-009b) — the caller keeps its dialog open and renders the
 * mapped refusal rather than treating every failure the same way.
 */
export function useDeleteAiProvider() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string): Promise<void> => {
      const response = await deleteAiProvider(id);
      if (response.status === 204) return;
      throw toAiProviderError(response.status, response.data);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: aiProviderKeys.all() });
    },
  });
}
